{
  "batteryCharge": {
    "legendWithUnitLabel": "Internal Battery Charge ({{unitLabel}})"
  },
  "batteryGraph": {
    "legend": "Input Voltage (V)"
  },
  "dailyVolumeWithUnitLabel": "Daily Volume (k{{unitLabel}})",
  "linkTo": "Analytics",
  "title": "Device Analytics",
  "waterUsage": {
    "graph": {
      "legend": "Daily Volume"
    }
  }
}
